import React, { useState, useEffect, useMemo } from 'react'
import debounce from 'lodash.debounce';
import { Button, Form } from 'react-bootstrap';
import Table from '../../components/table/Table';
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { BloggerAction, DeleteMultipleBloggerAction, getBloggerById } from '../../redux/Action/BloggerAction';
import { DELETE_MULTIPLE_BLOGGER } from '../../redux/type';
import { toast } from 'react-toastify'
import { AccountStatus } from '../../helper/Constant';
import Loading from '../../layout/Loading';
import DeleteLogo from './../../assets/img/Delete.png'
import DeleteModal from '../../components/modals/DeleteModal';

const BloggerAccount = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const urlParamStatus = searchParams.get('status')?.toUpperCase()

    const [allBloggerAccounts, setAllBloggerAccounts] = useState([])
    const [pagination, setPagination] = useState({
        page: 0,
        limit: 50,
    })

    const [totalCount, setTotalCount] = useState(0)
    const [filterStatus, setFilterStatus] = useState(urlParamStatus ? urlParamStatus : '')
    const [search, setSearch] = useState('')
    const [selectedRows, setSelectedRows] = useState([])
    const [deleteModal, setDeleteModal] = useState(false)

    const bloggerAccount = useSelector(state => state.bloggeraccount.account)
    const deleteMultiple = useSelector(state => state.bloggeraccount.deletemultiacc)
    const loading = useSelector(state => state.bloggeraccount.loading)

    useEffect(() => {
        dispatch(BloggerAction(pagination, search, filterStatus))
    }, [search, pagination, filterStatus, urlParamStatus])

    useEffect(() => {
        if (bloggerAccount) {
            setAllBloggerAccounts(bloggerAccount.data)
            setTotalCount(bloggerAccount.count)
        }

    }, [bloggerAccount])

    useEffect(() => {
        if (deleteMultiple && deleteMultiple.status === 200) {
            dispatch({
                type: DELETE_MULTIPLE_BLOGGER,
                payload: ""
            })
            toast.success(deleteMultiple.message)
            setSelectedRows([])
            dispatch(BloggerAction(pagination, search, filterStatus))
        }
    }, [deleteMultiple])

    const columns = [
        {
            id: 'application',
            numeric: true,
            disablePadding: false,
            label: 'Apps',
            selector: 'application'
        },
        {
            id: 'email',
            numeric: true,
            disablePadding: false,
            label: 'Email id',
            selector: 'email'
        },
        {
            id: 'password',
            numeric: true,
            disablePadding: false,
            label: 'Password',
            selector: 'password'
        },
        // {
        //     id: 'application',
        //     numeric: true,
        //     disablePadding: false,
        //     label: 'App Name',
        //     selector: 'application'
        // },
        {
            id: 'consoleName',
            numeric: true,
            disablePadding: false,
            label: 'Console Name',
            selector: 'consoleName'
        },
        // {
        //     id: 'web',
        //     numeric: true,
        //     disablePadding: false,
        //     label: 'Web Address',
        //     selector: 'web'
        // },
        // {
        //     id: 'developerAccountName',
        //     numeric: true,
        //     disablePadding: false,
        //     label: 'Developer Account Name',
        //     selector: 'developerAccountName'
        // },
        // {
        //     id: 'status',
        //     numeric: true,
        //     disablePadding: false,
        //     label: 'Status',
        //     selector: 'status'
        // },
        {
            id: 'action',
            numeric: true,
            disablePadding: false,
            label: 'Action',
            selector: 'action',
            action_type: ['VIEW', 'EDIT'],
        },
    ];

    const getAction = (obj) => {
        if (obj.type === "VIEW") {
            navigate(`/view-blogger/${obj.id}`)
            dispatch(getBloggerById(obj.id))
        }
        if (obj.type === "EDIT") {
            navigate(`/edit-blogger/${obj.id}`)
        }
    }

    const handleFilterStatus = (e) => {
        setPagination({ ...pagination, page: 0 })
        setFilterStatus(e.target.value)
    }

    const handleChange = useMemo(
        () =>
            debounce((e) => setSearch(e.target.value), 1000)
        , [search]);

    useEffect(() => {
        return () => handleChange.cancel();
    }, []);

    const handleMultipleDelete = () => {
        setDeleteModal(true)
    }

    const onConfirmDelete = () => {
        dispatch(DeleteMultipleBloggerAction(selectedRows))
        setDeleteModal(false)
    }

    return (
        <>
            <div className='android-main'>
                {/* <div className='text-end mb-3'>
                    </div> */}
                <div className='android-main-card p-0'>
                    <div className='card__header'>
                        <h1 className='title'>Blogger Account</h1>
                        <div className='card_filter'>
                            {selectedRows.length > 0 && (
                                <div >
                                    <img className='multi_delete_icon' onClick={handleMultipleDelete} src={DeleteLogo} alt='' />
                                </div>
                            )}
                            <div>
                                <Form.Select className='form-input' name='status' value={filterStatus} onChange={handleFilterStatus} aria-label="Default select example">
                                    <option value=''>All</option>
                                    <option value={AccountStatus.Active}>{AccountStatus.Active}</option>
                                    <option value={AccountStatus.Suspended}>{AccountStatus.Suspended}</option>
                                </Form.Select>
                            </div>
                            <div className='card_filter_search'>
                                <input type='search' placeholder=' Search...' defaultValue={search} onChange={handleChange}></input>
                            </div>
                            <Button className='header_button' onClick={() => navigate('/add-blogger')}>Add Blogger</Button>
                        </div>
                    </div>
                    {(loading && !allBloggerAccounts.length) ? <Loading /> : (
                        <Table
                            headCells={columns}
                            rows={allBloggerAccounts}
                            getAction={getAction}
                            pagination={pagination}
                            setPagination={setPagination}
                            count={totalCount}
                            selectedRows={selectedRows}
                            setSelectedRows={setSelectedRows}
                        />
                    )}
                </div>
            </div>
            {deleteModal && <DeleteModal show={deleteModal} onHide={() => setDeleteModal(false)} onConfirmDelete={onConfirmDelete} />}
        </>
    )
}

export default BloggerAccount